import React from 'react';

import Pagination from '@atlaskit/pagination';

import { Pagination as IPagination } from '@qality/common-model';

import './_qality-pagination.scss';

type Props = {
  pagination: IPagination;
  handleChange: (event: React.SyntheticEvent, value: number) => void;
  customClassName?: string;
};

export default function QalityPagination({
  pagination,
  handleChange,
  customClassName,
}: Props): JSX.Element {
  const generatePages = (): Array<number> => {
    const pages: Array<number> = [];

    if (pagination.totalPages === 0) {
      return [1];
    }

    for (let i = 1; i <= pagination.totalPages; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className={customClassName ?? 'pagination-container'}>
      <Pagination
        pages={generatePages()}
        onChange={(event, newPage) => {
          if (newPage > 0) {
            handleChange(event, newPage - 1);
          } else {
            handleChange(event, 0);
          }
        }}
        selectedIndex={pagination.currentPage}
      />
    </div>
  );
}
